import { module } from 'modujs';
import { gsap, Linear } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class extends module {
    constructor(m) {
        super(m);
    }
    init() {
        this.movable = this.$( 'movable' );
        this.tl = gsap.timeline()
            .fromTo( this.movable, {x: 0}, {x: "-100%", ease:Linear.easeNone });

        this.trigger = ScrollTrigger.create({
            scroller: document.querySelector( '[data-module-scroll] ' ),
            trigger: this.el,
            animation: this.tl,
            start: 'top bottom',
            end: 'top center',
            scrub: 1
        })
    }
    destroy(){
        this.trigger.kill();
        this.tl.kill();
    }
}
